import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseCreditNoteTemplates = [
  {
    id: '-211001',
    language: Language.EN,
    subject: 'Credit Note',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CREDIT_NOTE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>Please find your detailed credit note in the following link: {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-211002',
    language: Language.FR,
    subject: 'Note de crédit',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CREDIT_NOTE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Veuillez trouver votre note de crédit sur le lien suivant: {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-211003',
    language: Language.NL,
    subject: 'Creditnota',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CREDIT_NOTE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Gelieve uw gedetailleerde creditnota via de volgende link: {{pdfLink}}.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-211004',
    language: Language.DE,
    subject: 'Gutschrift',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CREDIT_NOTE,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Ihre detaillierte Gutschrift finden Sie unter folgendem Link: {{pdfLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
